/**
 * Animation easing functions
 */

export const EasingFunctions = {
    // no easing, no acceleration
    linear: function (t) { return t },
    // accelerating from zero velocity
    easeInQuad: function (t) { return t*t },
    // decelerating to zero velocity
    easeOutQuad: function (t) { return t*(2-t) },
    // acceleration until halfway, then deceleration
    easeInOutQuad: function (t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t },
    // accelerating from zero velocity
    easeInCubic: function (t) { return t*t*t },
    // decelerating to zero velocity
    easeOutCubic: function (t) { return (--t)*t*t+1 },
    // acceleration until halfway, then deceleration
    easeInOutCubic: function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 },
    // accelerating from zero velocity
    easeInQuart: function (t) { return t*t*t*t },
    // decelerating to zero velocity
    easeOutQuart: function (t) { return 1-(--t)*t*t*t },
    // acceleration until halfway, then deceleration
    easeInOutQuart: function (t) { return t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t },
    // accelerating from zero velocity
    easeInQuint: function (t) { return t*t*t*t*t },
    // decelerating to zero velocity
    easeOutQuint: function (t) { return 1+(--t)*t*t*t*t },
    // acceleration until halfway, then deceleration
    easeInOutQuint: function (t) { return t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t }
}

/**
 * Setup high dpi canvas
 *
 * @param $canvas
 * @param $container
 * @returns {CanvasRenderingContext2D | WebGLRenderingContext}
 */

export function setupCanvas( $canvas, $container ) {
    // Give the canvas pixel dimensions of their CSS
    // size * the device pixel ratio.
    let dpi = getDPI()
    $canvas.style.width='100%'
    $canvas.style.height='100%'
    $canvas.width = $container.width() * dpi
    $canvas.height = $container.height() * dpi

    return $canvas.getContext('2d')
}

/**
 * Rotate a 2d point around a 2d origin
 *
 * @param cx
 * @param cy
 * @param x
 * @param y
 * @param angle
 * @returns {*[]}
 */

export function rotate(cx, cy, x, y, angle) {
    let radians = (Math.PI / 180) * angle,
        cos = Math.cos(radians),
        sin = Math.sin(radians),
        nx = (cos * (x - cx)) + (sin * (y - cy)) + cx,
        ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
    return [nx, ny];
}

export function getDPI() {
    return window.devicePixelRatio || 1
}

export function formatFileSize(size) {
    const sizes = [' Bytes', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB'];
    for (let i = 1; i < sizes.length; i++) {
        if (size < Math.pow(1024, i))
            return (Math.round((size/Math.pow(1024, i-1))*100)/100) + sizes[i-1]
    }
    return size
}

export function tryParseJSON(value) {
    try {
        return JSON.parse(value)
    } catch (e) {}

    return value
}

export function truncateString(str, length) {
    if(!str) return ''
    const dots = str.length > length ? '…' : '';
    return str.substring(0, length) + dots;
}

export function onDocumentReady(callback) {
    if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll))
    {
        callback()
    } else {
        document.addEventListener("DOMContentLoaded", callback);
    }
}
